const en = {
  melhous: "MELHOUS",
  "melhous.service": "Services",
  "melhous.item_service": "Service Items",
  "melhous.special_services": "Special Services",
  "melhous.other_services": "Other Services",
  "melhous.gallery_areas": "Gallery",
  "melhous.title": "Title",
  "melhous.banner": "Banner",
  "melhous.desc": "Description",
  "melhous.address": "Address",
  "melhous.url": "URL",
  "melhous.wifi": "WiFi",
  "melhous.wifi_pass": "WiFi Password",
  "melhous.phone": "Phone",
  "melhous.reception_phone": "Reception Phone",
  "melhous.reception_phone2": "Reception Phone 2",
  "melhous.reception_phone3": "Reception Phone 3",
  "melhous.breakfast_start": "Breakfast Start",
  "melhous.breakfast_end": "Breakfast End",
  "melhous.lunch_start": "Lunch Start",
  "melhous.lunch_end": "Lunch End",
  "melhous.meal_start": "Dinner Start",
  "melhous.meal_end": "Dinner End",
  "melhous.check_in": "Check-In",
  "melhous.check_out": "Check-Out",
  "melhous.title_gallery": "Gallery Title",
  "melhous.desc_gallery": "Gallery Description",
  "melhous.service.title": "Title",
  "melhous.service.icon": "Icon",
  "melhous.service.button": "Button",
  "melhous.service.description": "Description",
  "melhous.item_service.title": "Title",
  "melhous.item_service.description": "Description",
  "melhous.item_service.icon": "Icon",
  "melhous.special_services.title": "Title",
  "melhous.special_services.image": "Image",
  "melhous.special_services.note": "Note",
  "melhous.special_services.permitted": "Permitted",
  "melhous.special_services.description": "Description",
  "melhous.other_services.title": "Title",
  "melhous.other_services.icon": "Icon",
  "melhous.other_services.description": "Description",
  "melhous.gallery_areas.title": "Title",
  "melhous.gallery_areas.image": "Image",
  "melhous.gallery_areas.video": "Video",
  "melhous.gallery_areas.desc": "Description",
  "crm.customer_service": "PQRS",
  "crm.customer_service.number": "Number",
  "crm.customer_service.state": "State",
  "crm.customer_service.party": "Party",
  "crm.customer_service.customer": "Customer",
  "crm.customer_service.address": "Address",
  "crm.customer_service.phone": "Phone",
  "crm.customer_service.city": "City",
  "crm.customer_service.case": "Case",
  "crm.customer_service.media": "Media",
  "crm.customer_service.description": "Description",
  "crm.customer_service.diagnose": "Diagnose",
  "crm.customer_service.response": "Response",
  "crm.customer_service.cs_date": "Date",
  "crm.customer_service.effective_date": "Effective Date",
  "crm.customer_service.satisfaction": "Satisfaction",
  "crm.customer_service.efficacy": "Efficacy",
  "crm.customer_service.responsible_employee": "Responsible",
  "crm.customer_service.department": "Department",
  "crm.customer_service.notes": "Notes",
  "crm.customer_service.action_plan": "Action Plan",
  "crm.customer_service.category_customer": "Category",
  "crm.customer_service.draft": "Draft",
  "crm.customer_service.open": "Open",
  "crm.customer_service.close": "Closed",
  "melhous.link_melhous": "Melhous Link (app URL, used in QR codes)",
  "melhous.require_table_qr": "Require Table QR",
  "melhous.guide_items": "Guide",
  "melhous.messages": "Messages",
  "melhous.request_types": "Request Types",
  "melhous.recommendations": "Recommendations",
  "melhous.guide_item": "Guide",
  "melhous.guide_item.section": "Section",
  "melhous.guide_item.title": "Title",
  "melhous.guide_item.description": "Description",
  "melhous.guide_item.schedule": "Schedule",
  "melhous.guide_item.link": "Link",
  "melhous.guide_item.sequence": "Sequence",
  "melhous.guide_item.hotel": "Hotel",
  "melhous.guide_item.nearby": "Nearby",
  "melhous.message": "Messages",
  "melhous.message.title": "Title",
  "melhous.message.body": "Message",
  "melhous.message.kind": "Type",
  "melhous.message.start": "Start",
  "melhous.message.end": "End",
  "melhous.message.active": "Active",
  "melhous.message.info": "Information",
  "melhous.message.promo": "Promotion",
  "melhous.message.alert": "Alert",
  "melhous.request_type": "Request Types",
  "melhous.request_type.name": "Name",
  "melhous.request_type.scope": "Scope",
  "melhous.request_type.active": "Active",
  "melhous.request_type.sequence": "Sequence",
  "melhous.request_type.table": "Table",
  "melhous.request_type.room": "Room",
  "melhous.request_type.both": "Table and Room",
  "melhous.request": "Requests",
  "melhous.request.type": "Type",
  "melhous.request.type_name": "Request",
  "melhous.request.scope": "Scope",
  "melhous.request.shop": "Shop",
  "melhous.request.place": "Place",
  "melhous.request.note": "Note",
  "melhous.request.state": "State",
  "melhous.request.attended_date": "Attended Date",
  "melhous.request.attend": "Attend",
  "melhous.request.pending": "Pending",
  "melhous.request.attended": "Attended",
  "melhous.request.table": "Table",
  "melhous.request.room": "Room",
  "melhous.recommendation": "Recommendations",
  "melhous.recommendation.name": "Name",
  "melhous.recommendation.message": "Message",
  "melhous.recommendation.trigger_category": "When Category",
  "melhous.recommendation.trigger_product": "When Product",
  "melhous.recommendation.active": "Active",
  "melhous.recommendation.sequence": "Sequence",
  "melhous.services": "Services",
  "melhous.special_services.icon": "Icon",
  "melhous.dash.tab.home": "Home",
  "melhous.dash.tab.hotel": "Hotel",
  "melhous.dash.tab.engage": "Guest Care",
  "melhous.dash.tab.requests": "Requests",
  "melhous.dash.tab.pqrs": "PQRS",
  "melhous.dash.tab.appearance": "Appearance",
  "melhous.dash.tab.qr": "QR codes",
  "melhous.dash.tab.home_help": "Follow the setup guide and check what is pending today.",
  "melhous.dash.tab.hotel_help": "Edit the hotel data.",
  "melhous.dash.tab.engage_help": "Set up the app link, stay guide, messages and request types.",
  "melhous.dash.tab.requests_help": "Attend the requests your guests make from the app.",
  "melhous.dash.tab.pqrs_help": "Answer your guests' requests, complaints, claims and suggestions.",
  "melhous.dash.tab.appearance_help": "Choose the colors, logo and sections your guests will see.",
  "melhous.dash.tab.qr_help": "Download the QR codes your guests use to open the app.",
  "melhous.dash.setup.title": "Get Melhous running",
  "melhous.dash.setup.help": "Follow the steps in order. They mark themselves once the data is ready.",
  "melhous.dash.setup.progress": "{done} of {total} ready",
  "melhous.dash.setup.done": "Setup complete",
  "melhous.dash.setup.show_steps": "Show steps",
  "melhous.dash.setup.hide_steps": "Hide steps",
  "melhous.dash.setup.hotel": "Review the hotel data",
  "melhous.dash.setup.hotel_hint": "It needs a title and phone, its own or inherited from the hotel.",
  "melhous.dash.setup.hotel_action": "Review hotel",
  "melhous.dash.setup.colors": "Choose the colors",
  "melhous.dash.setup.colors_hint": "Set the primary color or use the one inherited from the hotel.",
  "melhous.dash.setup.colors_action": "Choose colors",
  "melhous.dash.setup.link": "Write the Melhous Link",
  "melhous.dash.setup.link_hint": "It is the app URL. QR codes use it to open the app.",
  "melhous.dash.setup.link_action": "Write link",
  "melhous.dash.setup.care": "Prepare guest care",
  "melhous.dash.setup.care_hint": "Create request types and add messages or guide entries.",
  "melhous.dash.setup.care_action": "Prepare guest care",
  "melhous.dash.setup.qr": "Print the QR codes",
  "melhous.dash.setup.qr_hint": "Download them, print them and mark it here when they are ready.",
  "melhous.dash.setup.qr_action": "View QR codes",
  "melhous.dash.setup.qr_printed": "I printed them",
  "melhous.dash.block.link": "Link and table QR",
  "melhous.dash.block.link_hint": "Write the app URL and decide whether table orders require scanning the QR.",
  "melhous.dash.block.guide": "Guide",
  "melhous.dash.block.guide_hint": "Add what guests should know about the hotel and its surroundings.",
  "melhous.dash.block.messages": "Messages",
  "melhous.dash.block.messages_hint": "Add notices and promotions to show in the app.",
  "melhous.dash.block.request_types": "Request types",
  "melhous.dash.block.request_types_hint": "Add what guests can request from the table or room.",
  "melhous.dash.block.recommendations": "Recommendations",
  "melhous.dash.block.recommendations_hint": "Add rules by ordered category or product.",
  "melhous.dash.card.pending_requests": "Pending requests",
  "melhous.dash.card.active_messages": "Active messages",
  "melhous.dash.card.guide_items": "Guide",
  "melhous.dash.card.open_pqrs": "Open PQRS",
  "melhous.dash.hotel_notice": "Empty fields use the hotel configuration.",
  "melhous.dash.qr.melhous": "App home",
  "melhous.dash.qr.restaurant": "Restaurants",
  "melhous.dash.qr.hotel": "Hotel",
  "melhous.dash.qr.melhous_hint": "Opens the app home page.",
  "melhous.dash.qr.restaurant_hint": "Goes to the restaurants and their menus.",
  "melhous.dash.qr.hotel_hint": "Goes to the hotel information.",
  "melhous.dash.qr.table_notice": "Table and room QR codes are printed from Tryton.",
  "melhous.dash.qr.no_link": "The Melhous Link is missing",
  "melhous.dash.qr.no_link_help": "QR codes need the app URL. Write it in Guest Care to see them here.",
  "melhous.dash.qr.no_link_action": "Go to Guest Care",
  "melhous.dash.qr.download": "Download",
  "melhous.dash.qr.downloaded": "QR downloaded",
  "melhous.dash.qr.download_error": "The QR could not be downloaded. Reload the page and try again.",
  "melhous.dash.qr.copy": "Copy",
  "melhous.dash.qr.copied": "Link copied",
  "melhous.dash.qr.copy_error": "Could not copy. Select the link and copy it by hand.",
  "melhous.dash.save": "Save changes",
  "melhous.dash.create": "Create configuration",
  "melhous.dash.saved": "Saved successfully",
  "melhous.primary_color": "Primary color",
  "melhous.secondary_color": "Secondary color",
  "melhous.accent_color": "Accent color",
  "melhous.text_color": "Text color",
  "melhous.surface_color": "Surface color",
  "melhous.border_color": "Border color",
  "melhous.show_hotel": "Hotel",
  "melhous.show_restaurant": "Restaurants",
  "melhous.show_pqrs": "PQRS",
  "melhous.show_reservation": "Reservation",
  "melhous.show_experiences": "Experiences",
  "melhous.logo_link": "Logo link",
  "melhous.dash.colors": "Colors",
  "melhous.dash.section_on": "Visible in the app",
  "melhous.dash.section_off": "Hidden in the app",
  "melhous.dash.hotel.contact": "Contact",
  "melhous.dash.hotel.schedules": "Schedules",
  "melhous.dash.hotel.wifi": "Wi-Fi",
  "melhous.dash.hotel.breakfast": "Breakfast",
  "melhous.dash.hotel.lunch": "Lunch",
  "melhous.dash.hotel.dinner": "Dinner",
  "melhous.dash.hotel.error": "The hotel data could not be loaded.",
  "melhous.dash.hotel.save_error": "The changes could not be saved.",
  "melhous.dash.sections": "Sections",
  "melhous.dash.color.invalid": "Use a hex color, e.g. #1f3a5f",
  "melhous.dash.preview.title": "Preview",
  "melhous.logo": "Logo",
  "melhous.dash.card.pending_requests_hint": "Guest requests to attend",
  "melhous.dash.card.active_messages_hint": "Notices visible in the app",
  "melhous.dash.card.guide_items_hint": "Entries in the stay guide",
  "melhous.dash.card.open_pqrs_hint": "Cases to resolve",
  "melhous.dash.color.from_hotel": "From hotel",
  "melhous.dash.color.clear": "Clear",
  "melhous.dash.color.reset": "Reset to defaults",
  "melhous.dash.color.reset_hint": "Colors emptied in the form. Save to apply the change.",
  "melhous.dash.preview.help": "Basic outline of the site with its colors.",
  "melhous.dash.preview.hotel_name": "Your hotel",
  "melhous.dash.preview.hero": "Welcome",
  "melhous.dash.preview.section": "Restaurants",
  "melhous.dash.preview.card": "Restaurant",
  "melhous.dash.preview.card_action": "View menu",
  "melhous.dash.preview.cart": "View my order",
  "melhous.dash.inherited.title": "Data taken from the hotel",
  "melhous.dash.inherited.empty": "No data is being taken from the hotel configuration.",
  "melhous.recommendation.products": "Recommended products",
  "melhous.dash.hotel.data": "Details",
  "melhous.dash.block.qr_on": "Only with the QR printed on the table",
  "melhous.dash.block.qr_off": "Table QR not required",
  "melhous.dash.image.help": "Paste the image link. Recommended size: {size} px.",
  "melhous.dash.image.error": "The image could not be loaded. Check the link.",
  "melhous.dash.list.loading": "Loading…",
  "melhous.dash.list.load_error": "The list could not be loaded.",
  "melhous.dash.list.retry": "Try again",
  "melhous.dash.list.edit": "Edit",
  "melhous.dash.list.delete": "Delete",
  "melhous.dash.list.deleting": "Deleting…",
  "melhous.dash.list.delete_confirm": "Delete “{name}”? This action cannot be undone.",
  "melhous.dash.list.delete_error": "It could not be deleted.",
  "melhous.dash.list.save": "Save",
  "melhous.dash.list.saving": "Saving…",
  "melhous.dash.list.save_error": "It could not be saved.",
  "melhous.dash.list.cancel": "Cancel",
  "melhous.dash.list.required": "Fill in the field {field}.",
  "melhous.dash.list.invalid_end": "The end needs a start date and cannot be earlier than it.",
  "melhous.dash.list.untitled": "Untitled",
  "melhous.dash.list.inactive": "Inactive",
  "melhous.dash.list.order": "Order",
  "melhous.dash.list.order_hint": "Lower numbers appear first.",
  "melhous.dash.list.active_hint": "If you turn it off, it is hidden in the app without deleting it.",
  "melhous.dash.list.search": "Type to search",
  "melhous.dash.list.search_more": "There are more results. Keep typing to narrow them down.",
  "melhous.dash.list.search_error": "The search failed. Try again.",
  "melhous.dash.list.remove_tag": "Remove {name}",
  "melhous.dash.list.service_button": "“See more details” link",
  "melhous.dash.list.service_button_hint": "Optional. Adds a button with this link.",
  "melhous.dash.list.services_hint": "Shown as collapsible sections on the hotel page.",
  "melhous.dash.list.services_add": "Add service",
  "melhous.dash.list.services_empty": "Add your first service",
  "melhous.dash.list.item_services_hint": "If you add items, the app shows them instead of the description.",
  "melhous.dash.list.item_services_add": "Add item",
  "melhous.dash.list.item_services_empty": "Add the first item of this service",
  "melhous.dash.list.item_services_blocked": "Save the service to add items to it.",
  "melhous.dash.list.other_services_hint": "Shown as cards with an icon.",
  "melhous.dash.list.other_services_add": "Add other service",
  "melhous.dash.list.other_services_empty": "Add your first other service",
  "melhous.dash.list.special_services_hint": "Shown as cards with an image.",
  "melhous.dash.list.special_services_add": "Add special service",
  "melhous.dash.list.special_services_empty": "Add your first special service",
  "melhous.dash.list.special_description_hint": "Separate with | to show it as a list.",
  "melhous.dash.list.gallery_hint": "Photos of the hotel spaces.",
  "melhous.dash.list.gallery_add": "Add photo",
  "melhous.dash.list.gallery_empty": "Add your first photo",
  "melhous.dash.list.guide_add": "Add to the guide",
  "melhous.dash.list.guide_empty": "Add your first guide entry",
  "melhous.dash.list.messages_add": "Add message",
  "melhous.dash.list.messages_empty": "Add your first message",
  "melhous.dash.list.message_dates_hint": "Hotel time. Without dates, the message is always shown.",
  "melhous.dash.list.request_types_add": "Add request type",
  "melhous.dash.list.request_types_empty": "Add your first request type",
  "melhous.dash.list.recommendations_add": "Add recommendation",
  "melhous.dash.list.recommendations_empty": "Add your first recommendation",
  "melhous.dash.list.recommendation_products_hint": "Offered when the order includes that product or one from that category.",
  "melhous.dash.example.link": "https://",
  "melhous.dash.example.service_title": "E.g. Front desk",
  "melhous.dash.example.service_description": "E.g. Open 24 hours.",
  "melhous.dash.example.item_title": "E.g. Extra towels",
  "melhous.dash.example.other_title": "E.g. Laundry",
  "melhous.dash.example.other_description": "E.g. Same-day delivery.",
  "melhous.dash.example.special_title": "E.g. Spa",
  "melhous.dash.example.special_description": "E.g. Sauna | Massages | Jacuzzi",
  "melhous.dash.example.gallery_title": "E.g. Pool",
  "melhous.dash.example.gallery_description": "E.g. Open from 8:00 to 20:00.",
  "melhous.dash.example.guide_title": "E.g. Pool",
  "melhous.dash.example.guide_schedule": "E.g. 8:00 to 20:00",
  "melhous.dash.example.message_title": "E.g. Happy hour at the bar",
  "melhous.dash.example.request_name": "E.g. Call the waiter",
  "melhous.dash.example.recommendation_name": "E.g. Drinks with burgers",
  "melhous.dash.example.recommendation_message": "E.g. Pair it with a drink",
  "melhous.dash.icon.check": "Check mark",
  "melhous.dash.icon.clock": "Clock",
  "melhous.dash.icon.wifi": "Wi-Fi",
  "melhous.dash.icon.food": "Food",
  "melhous.dash.icon.breakfast": "Breakfast",
  "melhous.dash.icon.room_service": "Room service",
  "melhous.dash.icon.laundry": "Laundry",
  "melhous.dash.icon.parking": "Parking",
  "melhous.dash.icon.plane_arrival": "Plane arrival",
  "melhous.dash.icon.plane_departure": "Plane departure",
  "melhous.dash.icon.customer_service": "Customer service",
  "melhous.dash.icon.child_carer": "Children",
  "melhous.dash.icon.users": "People",
  "melhous.dash.icon.suitcase": "Luggage",
  "melhous.dash.icon.map": "Map",
  "melhous.dash.icon.phone": "Phone",
  "melhous.dash.icon.key": "Key",
  "melhous.dash.icon.calendar": "Calendar",
  "melhous.dash.icon.ticket": "Ticket",
  "melhous.dash.icon.shopping": "Shopping",
  "melhous.dash.icon.emergency": "Emergency",
  "melhous.dash.icon.moon": "Night",
  "melhous.dash.icon.shield": "Security",
  "melhous.dash.icon.hotel": "Hotel",
  "menu.home": "Home",
  "menu.hotel": "Hotel",
  "menu.appearance": "Appearance",
  "menu.engage": "Guest Care",
  "menu.qr": "QR codes",
  "menu.requests": "Requests",
  "menu.pqrs": "PQRS",
  "melhous.dash.tab.pending": "{count} pending",
};

export default en;
